import * as React from "react";
const TerpenesFlask = ({
  width = 16,
  height = 16,
}: {
  width?: number;
  height?: number;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
  >
    <path
      fill="#E6E6F4"
      d="M.832 11.694c1.447 2.505 4.457 3.773 7.715 2.636 3.259-1.136 7.493-6.297 6.046-8.803C13.146 3.022 6.24 1.973 2.95 3.872c-3.29 1.9-3.565 5.316-2.119 7.822Z"
    />
    <g
      stroke="#333"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.88}
      clipPath="url(#a)"
      fill="none"
    >
      <path d="M7.928 11.878s.854 1.696 2.29 1.57c2.912-.26 2.718-4.017 3.782-5.344a6.53 6.53 0 0 0-2.9-.65 6.525 6.525 0 0 0-2.888.7c-1.508.832-1.615 2.224-.284 3.724Z" />
      <path d="M10 10.454s-1.752.2-3 3M5.865 12.599a4.143 4.143 0 0 1 0-7.97V2.216h2.259V4.63a4.15 4.15 0 0 1 2.22 1.552M4.735 2.215H9.63" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M2 1.362h13v13H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default TerpenesFlask;
